module.exports = __webpack_public_path__ + "static/img/bbg.36e0ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/bbg.jpg
// module id = 9Orr
// module chunks = 1